import { CSSProperties } from 'react';

/**
 * PulseDot — the "live" indicator: a success-green dot with an expanding
 * ring pulse. Marks trips that are happening right now (kanban column
 * header, active cards).
 */
export interface PulseDotProps {
  /** Dot diameter in px. Default 7. */
  size?: number;
  style?: CSSProperties;
}

export function PulseDot({ size = 7, style }: PulseDotProps) {
  return (
    <>
      <style>{`
@keyframes sk-pulse-ring{
  0%{box-shadow:0 0 0 0 rgb(var(--success) / .55)}
  70%{box-shadow:0 0 0 7px rgb(var(--success) / 0)}
  100%{box-shadow:0 0 0 0 rgb(var(--success) / 0)}
}`}</style>
      <span
        style={{
          width: size, height: size, borderRadius: '50%',
          background: 'rgb(var(--success))', flexShrink: 0, display: 'block',
          animation: 'sk-pulse-ring 2.2s ease infinite',
          ...style,
        }}
      />
    </>
  );
}

export default PulseDot;
